var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({staticClass:"no-select",attrs:{"viewBox":_vm.viewBox,"width":_vm.size,"height":_vm.size}},_vm.$listeners),[_c('use',{attrs:{"href":_vm.spritepath,"xlink:href":_vm.spritepath}})])}
var staticRenderFns = []

export { render, staticRenderFns }